export const hashmapToArray = (hashmap) => {
  const outArray = Object.keys(hashmap).map((key) => hashmap[key]);
  return outArray;
};

export const getObjectFromHashmap = (hashmap, key) => hashmap[key];
